/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";

class AuthorityTraining extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTabletModeDetail = (training) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans>authoritytrainings_training</Trans>
                  </div>
                </td>
                <td className="showGrup">
                  {training.training ? training.training.name : ""}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { training } = this.props;
    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr>
            <td className="showGrup">
              {training.position ? training.position.name : ""}
            </td>
            <td className="showGrup">
              {training.idmRole ? training.idmRole.name : ""}
            </td>
            <td className="showGrup">
              {training.training ? training.training.name : ""}
            </td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            <td className="showGrup">
              {training.position ? training.position.name : ""}
            </td>
            <td className="showGrup">
              {training.idmRole ? training.idmRole.name : ""}
            </td>
          </tr>
          {this.renderTabletModeDetail(training)}
        </TabletBreakpoint>
      </>
    );
  }
}

export default AuthorityTraining;
